import NAV_SECTIONS from "../../content/navigation";
export default NAV_SECTIONS;
